export default __webpack_public_path__ + "static/media/ExerciseIllustrationRed.b287d989.svg";